<template>
  <div @click="openLink(feedData)" :class="queries ? 'pointer-event-none' : ''">
    <div class="vx-row flex justify-between flex-wrap">
      <div class="vx-col w-full flex justify-between mb-6 items-center gap-2">
        <div class="flex items-center justify-start">
          <a
            href="#"
            :data-analytics="feedData && feedData.itemId ? feedData.itemId : ''"
          >
            <h4 class="text-left clip-text--2 font-semibold text-xl">
              {{ feedData.title | title }}
            </h4>
          </a>

          <div class="flex items-center">
            <vs-tooltip :text="tooltiptext">
              <img class="mx-4 w-5" :src="imgSrc" :alt="imgAlt"
            /></vs-tooltip>
          </div>
        </div>

        <div>
          <img
            @click="queriesPopup"
            class="alert-icon"
            :src="alertIcon"
            alt="alert"
          />
        </div>
      </div>

      <div v-if="feedData.isDeactivated">
      </div>

      <div
        v-else-if="status !== 'notInterested'"
        class="vx-col items-left md:w-3/4"
        :class="{ 'md:w-3/4': feedData.imageUrl }"
      >
        <!-- if item is assigned by org  -->
        <div
          class="items-center mb-3 hidden"
          v-if="
            feedData.assignedBy && feedData.assignedBy.type === 'organization'
          "
          style="display: none"
        >
          <div class="h-8 w-8 overflow-none">
            <img
              v-if="feedData.sourceLogoUrl"
              class="w-full h-full object-cover rounded-full"
              :src="constants.s3Bucket + '/organization/logo/' + orgLogo"
              :alt="feedData.source ? feedData.source : 'GetBoarded'"
              @error="altSrcImage"
            />
          </div>
          <div class="font-semibold text-lg text-black ml-2">
            Assigned By {{ orgName }}
            {{ getAssignedOrganization(feedData.assignedBy._id) }}
          </div>
        </div>

        <div
          class="flex items-center mb-4 justify-items-center gap-2"
          v-if="feedData"
        >
          <div class="h-8 w-8 overflow-none">
            <img
              v-if="feedData.sourceLogoUrl"
              class="w-full h-full object-cover rounded-full"
              style="border: 1px solid #ffedbe"
              :src="feedData.sourceLogoUrl"
              :alt="feedData.source ? feedData.source : 'GetBoarded'"
              @error="altSrcImage"
            />
          </div>
          <div class="font-semibold text-lg text-black">
            {{ feedData.source ? feedData.source : "GetBoarded" }}
          </div>
          <div
            class="flex items-center ml-2"
            v-if="feedData.assignedBy && feedData.assignedBy.type === 'user'"
          >
            <div class="font-normal italic text-sm text-black text-left">
              - Suggested By {{ userName }}
              {{ getAssignedUser(feedData.assignedBy._id) }}
            </div>
          </div>
          <!-- if item is assigned by org  -->
          <div
            class="flex items-center ml-2"
            v-if="
              feedData.assignedBy && feedData.assignedBy.type === 'organization'
            "
          >
            <div class="font-normal italic text-sm text-black text-left">
              - Suggested By {{ orgName }}
              {{ getAssignedOrganization(feedData.assignedBy._id) }}
            </div>
          </div>
          <span
            style="
              height: 3px;
              width: 3px;
              border-radius: 50%;
              background: #000000;
              opacity: 0.3;
              margin: 0rem 0.7rem;
            "
          >
          </span>
          <div
            class="font-semibold text-lg"
            style="color: #12b76a; display: none"
          >
            {{ feedData.xp ? feedData.xp : "0" }} XP
          </div>
        </div>

        <div class="custom-height">
          <p class="inter" v-if="typeof feedData.description === 'string'">
            {{ feedData.description }}
          </p>
          <div class="inter" v-else>
            <div
              v-for="(data, index) in feedData.description"
              :key="index"
              v-html="data"
            ></div>
          </div>
        </div>
      </div>


      <div v-if="feedData.isDeactivated">
      </div>

      <div
        v-else-if="status !== 'notInterested'"
        class="vx-col w-full md:w-1/4 relative flex items-center justify-end overflow-none test"
      >
        <img
          class="border-6 feed__img h-full w-full object-cover"
          :src="feedData.imageUrl ? feedData.imageUrl : randomFeedImage"
          @error="randomFeedImage"
        />

        <div class="w-full h-full absolute grid place-content-center">
          <div
            class="flex items-center justify-center justify-self-center"
            style="place-self: center"
          >
            <img
              v-if="feedData && feedData.format === 'WATCH'"
              class="w-8 h-8 ml-8"
              src="@/assets/images/user-dashboard/play.svg"
              alt=""
            />

            <img
              v-else-if="feedData && feedData.format === 'LISTEN'"
              class="w-8 h-8 ml-8"
              src="@/assets/images/user-dashboard/headphone.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>


    <div v-if="feedData.isDeactivated"></div>

    <div
    v-else-if="status !== 'notInterested'"
      style="
        padding-bottom: 1px;
        background: #202020;
        opacity: 0.1;
        margin: 1rem 0rem 0 0;
      "
    ></div>

    <div v-if="feedData.isDeactivated" class="text-left ">
      <h6 class="py-3 px-6 pull-back-content w-fit">
        This content was pulled back from Admin. This content was removed from
        the Organizational Library and hence it is not available anymore.
      </h6>
    </div>

    <div
      v-else-if="status !== 'notInterested'"
      class="mt-4 flex flex-col md:flex-row justify-between items-start md:items-end"
    >
      <div
        class="md:w-9/12 w-full flex flex-wrap items-center mb-8 md:mb-0"
        style="width: fit-content"
        v-if="feedData.tags.includes(',')"
      >
        <vs-chip
          class="m-1"
          v-for="(tag, index) in feedData.tags.split(',')"
          :key="index"
          >{{ getAbilityByTag(tag) }}</vs-chip
        >

        <div
          v-if="feedData.behaviors && feedData.type === 'soft'"
          class="dot mx-2"
        >
          .
        </div>
        <vs-chip
          v-show="feedData.behaviors && feedData.type === 'soft'"
          style="color: #292929; font-weight: 500"
          v-for="(behavior, index) in feedData.behaviors"
          :key="index + 'behavior'"
          >#{{ behavior }}</vs-chip
        >
      </div>

      <div
        class="md:w-9/12 w-full flex flex-wrap items-center mb-8 md:mb-0"
        style="width: fit-content"
        v-else
      >
        <vs-chip
          class="m-1"
          v-for="(tag, index) in feedData.tags"
          :key="index"
          >{{ getAbilityByTag(tag) }}</vs-chip
        >

        <div
          v-if="feedData.behaviors && feedData.type === 'soft'"
          class="dot mx-2"
        >
          .
        </div>
        <vs-chip
          v-show="feedData.behaviors && feedData.type === 'soft'"
          style="color: #292929; font-weight: 500"
          v-for="(behavior, index) in feedData.behaviors"
          :key="index + 'behavior'"
          >#{{ behavior }}</vs-chip
        >
      </div>

      <!-- <div
        v-if="feedData.status === 'do'"
        class="custom-btn cursor-pointer px-4 py-2 flex items-center justify-center"
        @click="
          setDevelopmentStage({
            status: 'doing',
            itemId: feedData.itemId,
            item: feedData,
            type: feedData.type,
          })
        "
      >
        <vs-icon
          class="text-xl mr-1"
          color="#798BA0"
          icon="icon-plus-circle"
          icon-pack="feather"
        />
        Add Activity
      </div>

      <div
        v-else-if="feedData.status === 'doing'"
        class="custom-btn cursor-pointer px-4 py-2 flex items-center justify-center"
        @click="
          setDevelopmentStage({
            status: 'done',
            itemId: feedData.itemId,
            type: feedData.type,
          })
        "
      >
        <vs-icon
          class="text-xl mr-1"
          color="#798BA0"
          icon="icon-check-circle"
          icon-pack="feather"
        />
        Complete Activity
      </div> -->
      <!-- ** do doing done chips ** -->
      <div class="flex items-center justify-center gap-2">
        <img
          v-if="status === 'do'"
          class=""
          src="@/assets/images/icons/pin-fill.svg"
          alt=""
        />
        <div
          @click="
            setDevelopmentStage({
              status: 'do',
              itemId: feedData.itemId,
              type: feedData.type
                ? feedData.type
                : feedData.itemType
                ? feedData.itemType
                : '',
            })
          "
          v-else
          class="flex mr-25"
        >
          <img class="" src="@/assets/images/icons/pin-stroke.svg" alt="" />
        </div>
        <div
          class="dodoingdone"
          style="
            display: grid;
            grid-auto-flow: column;
            place-content: center;
            justify-content: end;
            align-items: center;
            gap: 1rem;
            width: fit-content;
          "
        >
          <div
            class="h-full"
            style="
              height: 7rem;
              padding: 0rem 0.2rem;
              padding-top: 0.2rem;
              border-radius: 10rem;
              border: 2px solid #f2f2f2;
            "
          >
            <span
              class="flex"
              :class="feedData.type === 'article' ? 'hidden' : ''"
            >
              <!-- <vs-chip
              class="text-black font-bold"
              @click.native="
                setDevelopmentStage({
                  status: 'do',
                  itemId: feedData.itemId,
                  type: feedData.type
                    ? feedData.type
                    : feedData.itemType
                    ? feedData.itemType
                    : '',
                })
              "
              :color="status === 'do' ? '#f2c244' : ''"
              >Do</vs-chip
            > -->

              <vs-chip
                class="text-black font-bold"
                @click.native="
                  setDevelopmentStage({
                    status: 'doing',
                    itemId: feedData.itemId,
                    type: feedData.type
                      ? feedData.type
                      : feedData.itemType
                      ? feedData.itemType
                      : '',
                  })
                "
                :color="status === 'doing' ? '#f2c244' : ''"
                >Doing</vs-chip
              >
              <vs-chip
                class="text-black font-bold"
                @click.native="
                  setDevelopmentStage({
                    status: 'done',
                    itemId: feedData.itemId,
                    type: feedData.type
                      ? feedData.type
                      : feedData.itemType
                      ? feedData.itemType
                      : '',
                  })
                "
                :color="status === 'done' ? '#f2c244' : ''"
                >Done</vs-chip
              >
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        typeof feedData.instructions === 'object' &&
        feedData.instructions.length > 0
      "
      class="text-left"
    >
      <div
        style="padding-bottom: 1px; background: #202020; opacity: 0.1"
        class="mt-4 md:mt-6 mb-2 md:mb-4"
      />
      <h4 class="font-bold text-black">Instructions</h4>
      <p class="inter" v-if="typeof feedData.instructions === 'string'">
        {{ feedData.instructions }}
      </p>
      <div class="inter" v-else>
        <div
          v-for="(data, index) in feedData.instructions"
          :key="index"
          v-html="data"
        ></div>
      </div>
    </div>

    <vs-popup :active.sync="queries" title="" v-if="queries">
      <div
        class="flex items-center overlay__inner__queries"
        @click.stop="
          setDevelopmentStage({
            status: 'notInterested',
            itemId: feedData.itemId,
            type: feedData.type
              ? feedData.type
              : feedData.itemType
              ? feedData.itemType
              : '',
          })
        "
      >
        <vs-icon size="medium" icon="help_outline"></vs-icon>
        <h4 class="font-medium mx-2">Not interested in this item</h4>
      </div>
      <!-- <div
            class="flex items-center mt-2 overlay__inner__queries"
            @click.stop="whyThisRecommendationPopup"
          >
            <vs-icon size="medium" icon="help_outline"></vs-icon>
            <h4 class="font-medium mx-2">Why this recommendation</h4>
          </div> -->
      <!-- <div class="flex items-center mt-2 overlay__inner__queries">
            <vs-icon size="medium" icon="add_circle_outline"></vs-icon>
            <h4 class="font-medium mx-2">Add to my development plan</h4>
          </div> -->
      <div
        class="flex items-center mt-2 overlay__inner__queries"
        @click.stop="
          reportLink({
            itemId: feedData.itemId,
            itemType: feedData.type
              ? feedData.type
              : feedData.itemType
              ? feedData.itemType
              : '',
            index: feedIndex,
          })
        "
      >
        <vs-icon size="medium" icon="link_off" />
        <h4 class="font-medium mx-2">Report broken link</h4>
      </div>
      <!-- <div class="flex items-center mt-2 overlay__inner__queries">
        <vs-icon size="medium" icon="post_add" />
        <h4 class="font-medium mx-2">Add/remove tags from my development</h4>
      </div> -->
      <!-- <div class="flex items-center mt-2 overlay__inner__queries">
          <vs-icon size="medium" icon="outlined_flag"></vs-icon>
          <h4 class="font-medium mx-2">Report Content</h4>
        </div> -->

      <!--<vs-icon
          class="overlay__bg__cross-icon pointer-events-none cursor-pointer"
          sie="medium"
          icon="close"
          @click.stop="queriesPopup"
        /> -->
    </vs-popup>

    <div
      v-if="whyThisRecommendation"
      class="overlay__bg"
      @click="whyThisRecommendationPopup"
    >
      <div class="relative">
        <span class="overlay__inner">
          <div class="flex items-center overlay__inner__queries">
            <vs-icon size="medium" icon="outlined_flag"></vs-icon>
            <h3 class="font-medium mx-2">Report Content</h3>
          </div>
        </span>
        <vs-icon
          class="overlay__bg__cross-icon"
          size="medium"
          icon="close"
          @click.stop="whyThisRecommendationPopup"
        />
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/constants";
import techImage from "../../../../src/assets/images/user-dashboard/tech.svg";
import projectImage from "../../../../src/assets/images/user-dashboard/project.svg";
import softImage from "../../../../src/assets/images/user-dashboard/soft.svg";
import newsImage from "../../../../src/assets/images/user-dashboard/news.svg";
import info from "../../../../src/assets/images/user-dashboard/info.svg";
import cross from "../../../../src/assets/images/user-dashboard/crossIcon.svg";

import personality from "@/assets/data/personality.js";

export default {
  data() {
    return {
      constants,
      tags: [],
      imgSrc: "",
      imgAlt: "",
      tooltiptext: "",
      alertIcon: cross,
      queries: false,
      status: "",
      whyThisRecommendation: false,
      disableLink: false,
      orgItemIds: [],
      id: "619f758aa209bcda350c9cf6",
      userName: "",
      userProfilePic: "",
      orgName: "",
      orgLogo: "",
      defaultPersonality: personality.defaultPersonalityTraits_en,
    };
  },
  props: {
    feedData: {
      type: Object,
      required: true,
    },
    feedIndex: {
      type: Number,
      required: true,
    },
  },
  emits: ["recommendation"],
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    orgAndCourse() {
      return this.$store.state.feed.distributedItems;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    userOrganization() {
      return this.$store.state.users.selectedOrganization;
    },
    // status(){
    //   return this.feedData.status;
    // }
  },
  watch: {
    // queries(newVal) {
    //   !newVal === false
    //     ? document.body.classList.add("noscroll")
    //     : document.body.classList.remove("noscroll");
    // },
    feedData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal.type || newVal.itemType == "tech") {
          this.imgSrc = techImage;
          this.imgAlt = "Tech Skill";
          this.tooltiptext = "Functional Skill";
        } else if (newVal.type || newVal.itemType == "soft") {
          this.imgSrc = softImage;
          this.imgAlt = "Soft Skill";
          this.tooltiptext = "Soft Skill";
        } else if (newVal.type || newVal.itemType == "article") {
          this.imgSrc = newsImage;
          this.imgAlt = "News";
          this.tooltiptext = "News";
        } else {
          this.imgSrc = projectImage;
          this.imgAlt = "Project";
          this.tooltiptext = "Project";
        }
        this.status = newVal.status;
      },
    },
    status(newVal) {
      if (newVal) {
        return (this.status = newVal);
      }
    },
  },
  methods: {
    queriesPopup() {
      this.queries = !this.queries;
    },
    setDevelopmentStage(i) {
      this.disableLink = true;
      this.status = i.status;
      const payload = {
        type: i.type,
        getboardedId: this.userData._id,
        itemId: i.itemId,
        status: i.status,
      };
      this.status = i.status;
      if (i.status === "notInterested") {
        this.queries = !this.queries;
        this.$emit("recommendation", i.itemId, true, this.feedIndex);
      } else if (i.status === "doing" || i.status === "done") {
        if (i.status === "doing") {
          this.$store.commit("feed/ADD_DOING_ITEMS", i.item);
          this.$vs.notify({
            color: "success",
            text: "You have marked this item in your 'doing' activity queue. Make sure to mark it 'done' when you are finished with it.",
            time: 5000,
          });
        }
        if (i.status === "done") {
          this.$vs.notify({
            color: "success",
            text: "This item is marked 'done'. Learning is it's own reward...yet, we are working on topping it up with validations and rewards. This transaction may have an applicable claim later.",
            time: 5000,
          });
        }
        // this.queries = !this.queries;
        // this.$emit("recommendation", i.itemId, true);
      } else if (i.status === "do") {
        this.$vs.notify({
          color: "success",
          text: "You have marked your item back to 'do'. Would you like to drop a feedback? This may help us give better recommendations.",
          time: 5000,
        });
        this.queries = true;
      }
      this.$store
        .dispatch("feed/updateCourseStatus", payload)
        .then((res) => {})
        .catch((err) => {
          // console.log(err);
        })
        .finally(() => {
          this.disableLink = false;
        });
    },
    // notInterested(i) {
    //   this.queries = !this.queries;
    //   this.$emit("recommendation", i);
    // },
    whyThisRecommendationPopup() {
      this.queries = !this.queries;
      this.whyThisRecommendation = !this.whyThisRecommendation;
    },
    openLink(item) {
      let link = `https://library.getboarded.com/redirect-page?itemId=${
        item.itemId
      }&type=${item.type || item.itemType}&gbuid=${this.userData._id}&gborgid=${
        this.userOrganization.organizationId
      }&redirectsourceid=USER_DASHBOARD`;
      if (link && !this.queries && !this.disableLink) {
        window.open(link, "_blank");
      }
    },
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    altSrcImage(e) {
      return (e.target.src = `https://hostedboringavatars.vercel.app/api/beam?name=bauhaus`);
    },
    getAssignedUser(id) {
      this.$store
        .dispatch("users/getAssignedUser", id)
        .then((res) => {
          this.userProfilePic = res.profilePictureUrl
            ? res.profilePictureUrl
            : "";
          this.userName = `${res.firstName} ${
            res.lastName ? res.lastName : ""
          }`;
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    getAssignedOrganization(id) {
      this.$store
        .dispatch("organization/getAssignedOrganization", id)
        .then((res) => {
          this.orgLogo = res.logo;
          this.orgName = res.name;
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    getAbilityByTag(id) {
      let abilityObj = this.defaultPersonality.find((x) => x.id === id);
      if (abilityObj) {
        return abilityObj.ability;
      } else {
        return id;
      }
    },
    reportLink(payload) {
      this.disableLink = true;
      this.$store
        .dispatch("feed/reportBrokenLink", payload)
        .then((res) => {
          if (res === "SUCCESS") {
            this.queries = !this.queries;
            this.$vs.notify({
              color: "success",
              text: "Report submitted successfully. Thank you for your contribution.",
              time: 5000,
            });
          }
        })
        .catch((err) => {
          // console.log(err);
        })
        .finally(() => {
          this.disableLink = false;
        });
    },
  },
  mounted() {
    if (this.feedData.type || this.feedData.itemType == "tech") {
      this.imgSrc = techImage;
      this.imgAlt = "Tech Skill";
      this.tooltiptext = "Tech Skill";
    } else if (this.feedData.type || this.feedData.itemType == "soft") {
      this.imgSrc = softImage;
      this.imgAlt = "Soft Skill";
      this.tooltiptext = "Soft Skill";
    } else if (this.feedData.type || this.feedData.itemType == "article") {
      this.imgSrc = newsImage;
      this.imgAlt = "News";
      this.tooltiptext = "News";
    } else {
      this.imgSrc = projectImage;
      this.imgAlt = "Project";
      this.tooltiptext = "Project";
    }
    this.status = this.feedData.status;
  },
};
</script>

<style scoped>
.feed--item {
  background: #ffffff;
  border-radius: 6px;
}

.border-6 {
  border-radius: 6px;
}

.dodoingdone .con-vs-chip {
  background-color: white;
}

.con-vs-chip >>> .text-chip {
  text-transform: capitalize;
}

.con-vs-popup >>> .vs-popup {
  width: 42%;
}

.con-vs-popup >>> .vs-popup--content {
  padding: 0;
  margin: 0;
}

.clip-text {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clip-text--2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.alert-icon {
  cursor: pointer;
}

.feed__img {
  filter: grayscale(0.2);
  object-fit: cover;
  min-width: 10rem;
  max-width: 100%;
  max-height: 12em;
}

.custom-height {
  min-height: 10em;
}

.pull-back-content {
  background: rgba(240, 68, 56, 0.03);
  border: 2px solid rgba(240, 68, 56, 0.1);
  border-radius: 0.5rem;
  color: #f04438;
}

.dot {
  position: relative;
  top: -0.3em;
  width: 10px;
  font-weight: 700;
  font-size: 2.5em;
  color: #757575;
}
</style>

<style lang="scss" scoped>
.overlay {
  &__bg {
    top: 0;
    left: 0;
    z-index: 100000000;
    background-color: #82828169;
    position: fixed;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    &__cross-icon {
      position: absolute;
      padding: 0.6em;
      display: flex;
      align-items: center;
      justify-content: center;
      top: -0.3em;
      right: -0.6em;
      border-radius: 50%;
      background: #fff;
      color: #798ba0;
      box-shadow: -2px 2px 9px 0px #8080807d;
      cursor: pointer;
    }
  }

  &__inner {
    overflow: hidden;
    border-radius: 6px;
    background-color: #fff;
    justify-content: center;
    display: flex;
    flex-direction: column;

    &__queries {
      padding: 1em 0.8em;

      &:hover {
        background: #0000000d;
        cursor: pointer;
      }
    }
  }
}

.custom-btn {
  background: #f2f4f7;
  border: 1.5px solid #e4e7ec;
  border-radius: 2em;
}

@media only screen and (max-width: 991px) {
  .con-vs-popup >>> .vs-popup {
    width: 56%;
  }

  .overlay {
    &__inner {
      width: 85%;

      &__cross-icon {
        padding: 0.5em;
        font-size: 1.8em;
      }

      &__queries {
        text-align: left !important;

        h3 {
          font-size: 1.25em;
        }
      }
    }
  }

  .custom-height {
    height: fit-content;
    margin-bottom: 1rem;
  }

  .feed__img {
    max-width: none;
  }
}

@media only screen and (max-width: 660px) {
  .con-vs-popup >>> .vs-popup {
    width: 95%;
  }
}
</style>
